export const SERVICES_DATA = [
  // —— Heating ————————————————————————
  {
    id: 1,
    slug: 'boiler-installations',
    title: 'Boiler Installations',
    description:
      'High-efficiency boiler replacements and new installs, sized and commissioned by certified Gas Safe engineers.',
    image: 'https://picsum.photos/seed/boiler-installations/640/480',
    phone: '+447506113669',
    cta: 'Call Now',
    tags: ['heating', 'gas', 'boiler'],
  },
  {
    id: 2,
    slug: 'heat-pumps',
    title: 'Heat Pumps',
    description:
      'Ground- and air-source heat-pump design, installation and servicing for ultra-low-carbon heating.',
    image: 'https://picsum.photos/seed/heat-pumps/640/480',
    phone: '+447506113669',
    cta: 'Call Now',
    tags: ['heating', 'renewables', 'heat-pump'],
  },
  {
    id: 3,
    slug: 'heating-controls',
    title: 'Heating Controls',
    description:
      'Smart thermostats, zoning and weather compensation to cut running costs and keep every room comfortable.',
    image: 'https://picsum.photos/seed/heating-controls/640/480',
    cta: 'Call Now',
    tags: ['heating', 'controls', 'smart'],
  },

  // —— Plumbing ————————————————————————
  {
    id: 4,
    slug: 'general-plumbing',
    title: 'General Plumbing',
    description:
      'From leaking taps to complete pipework renewals — rapid, reliable plumbing for any domestic job.',
    image: 'https://picsum.photos/seed/general-plumbing/640/480',
    cta: 'Call Now',
    tags: ['plumbing', 'repairs'],
  },
  {
    id: 5,
    slug: 'bathroom-renovations',
    title: 'Bathroom Renovations',
    description:
      'Full design-and-build bathrooms, wet-rooms and ensuites with premium fixtures and flawless tiling.',
    image: 'https://picsum.photos/seed/bathroom-renovations/640/480',
    cta: 'Call Now',
    tags: ['plumbing', 'bathroom', 'renovation'],
  },
  {
    id: 6,
    slug: 'leak-repairs',
    title: 'Leak Repairs',
    description:
      'Emergency call-outs 24/7 for burst pipes, hidden leaks and water-damage mitigation.',
    image: 'https://picsum.photos/seed/leak-repairs/640/480',
    phone: '+447506113669',
    cta: 'Call Now',
    tags: ['plumbing', 'emergency'],
  },

  // —— Commercial —————————————————————
  {
    id: 7,
    slug: 'commercial-boilers',
    title: 'Commercial Boilers',
    description:
      'High-output boilers, cascades and pressurised systems for offices, schools and industrial sites.',
    image: 'https://picsum.photos/seed/commercial-boilers/640/480',
    cta: 'Call Now',
    tags: ['commercial', 'boiler'],
  },
  {
    id: 8,
    slug: 'plant-room-installations',
    title: 'Plant Room Installations',
    description:
      'Turn-key plant rooms including pumps, pressurisation, BMS interfaces and full commissioning.',
    image: 'https://picsum.photos/seed/plant-room-installations/640/480',
    cta: 'Call Now',
    tags: ['commercial', 'plant-room'],
  },
  {
    id: 9,
    slug: 'maintenance-contracts',
    title: 'Maintenance Contracts',
    description:
      'Planned preventative maintenance to keep commercial heating & hot-water systems at peak efficiency.',
    image: 'https://picsum.photos/seed/maintenance-contracts/640/480',
    cta: 'Call Now',
    tags: ['commercial', 'service-contract'],
  },
];
